import { render, staticRenderFns } from "./WorkPlans.vue?vue&type=template&id=1dfcc5e4&"
import script from "./WorkPlans.vue?vue&type=script&lang=js&"
export * from "./WorkPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports